// CRUD (só em memória, sobe no save do circuito) da lista de contatos de escalação
// dentro de formData.lastMilePartner.escalationContacts. Extraído de circuito/index.js
// (etapa 19, passo 2, do plano de melhorias) — mesmo comportamento, sem chamada de API própria.
export default function useEscalationContacts({
  formData,
  setFormData,
  setChanged,
  setShowAllContacts,
}) {
  const handleAddContatoEscalacao = () => {
    setChanged(true);
    setShowAllContacts(true);
    setFormData((prev) => ({
      ...prev,
      lastMilePartner: {
        ...prev?.lastMilePartner,
        escalationContacts: [
          ...prev?.lastMilePartner?.escalationContacts,
          {
            id: "",
            name: "",
            role: "",
            phone: "",
            escalationTime: 0,
            clientCircuitId: "",
          },
        ],
      },
    }));
  };

  const handleRemoveContatoEscalacao = (index) => {
    setChanged(true);
    setFormData((prev) => ({
      ...prev,
      lastMilePartner: {
        ...prev?.lastMilePartner,
        escalationContacts: prev?.lastMilePartner?.escalationContacts.filter(
          (_, i) => i !== index,
        ),
      },
    }));
  };

  const handleContatoEscalacaoChange = (index, field, value) => {
    setChanged(true);
    const novosContatos = [...formData?.lastMilePartner?.escalationContacts];
    novosContatos[index] = {
      ...novosContatos[index],
      [field]: value,
    };
    setFormData((prev) => ({
      ...prev,
      lastMilePartner: {
        ...prev?.lastMilePartner,
        escalationContacts: novosContatos,
      },
    }));
  };

  return {
    handleAddContatoEscalacao,
    handleRemoveContatoEscalacao,
    handleContatoEscalacaoChange,
  };
}
